export const additional = {
  brightYellow: '#FFE033',
  hotPink: '#ED4C82',
  dangerRed: '#FF333D',
  turquoise: '#00E5DA',
  limeGreen: '#C2FF1A',
  vibrandBlue: '#0073EE',
  mysteriousPurple: '#8711DC',
} satisfies Record<string, string>
